var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nav--wrapper"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"nav--text"},[_vm._v("Shattered Spirits")])]),_c('about',{staticClass:"about d-none d-lg-block"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }